import { useRouterState } from "@tanstack/react-router";
import { useEffect, useState } from "react";

/* The screen's title sits in the row with back and home; it has gone once it is off the top. */
const GONE_PX = 4;

/* The heading's own words, without the count a list sets beside them ("Residents", not
   "Residents62"). */
export function headingWords(heading: HTMLElement): string | null {
  const own = [...heading.childNodes]
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent ?? "")
    .join("")
    .trim();
  return own || heading.innerText.trim().split("\n")[0] || null;
}

/** The screen's own first heading once scrolled past, so it is the screen's words ("Wilma Bennett",
 * not "Residents"); the phone's floating buttons carry it. */
export function useTitleOffScreen(): string | null {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const [title, setTitle] = useState<string | null>(null);
  useEffect(() => {
    // Core's dashboard keeps its header; nothing floats there to carry a title.
    if (pathname === "/") return;
    let frame = 0;
    const read = () => {
      frame = 0;
      const heading = document.querySelector<HTMLElement>("#main-content :is(h1, h2)");
      const gone = heading !== null && heading.getBoundingClientRect().bottom < GONE_PX;
      setTitle(gone ? headingWords(heading) : null);
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(read);
    };
    read();
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    return () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("scroll", onScroll, { capture: true });
    };
  }, [pathname]);
  return title;
}
